import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { OBJECT_DESCRIPTION_RULE, FORM_SELECT_RULE } from "../../../utils/validation-utils";
import IdNameModel from "../../../models/common/IdNameModel";
import AddProfilesStatusUpdateModel from "../../../models/company/addProfiles/request/AddProfilesStatusUpdateModel";
import toasterUtils from "../../../utils/toaster-utils";
import { Autocomplete, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

interface StatusUpdateProps {
    objStatusUpdate: AddProfilesStatusUpdateModel;
    statusList: IdNameModel[];
    onCloseStatusUpdate: () => void;
    onStatusUpdate: (objStatusUpdate: AddProfilesStatusUpdateModel) => void;
}

const StatusUpdateComponent = (props: StatusUpdateProps) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid },
    } = useForm<AddProfilesStatusUpdateModel>({
        mode: "onChange",
        defaultValues: {
            ...props.objStatusUpdate,
            followUpDate: props.objStatusUpdate.followUpDate ? (dayjs(props.objStatusUpdate.followUpDate) as any) : null,
        },
    });

    const onSubmit = (formData: AddProfilesStatusUpdateModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        props.onStatusUpdate(formData);
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-6">
                            <Controller name="statusId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={props.statusList.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.statusList} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Status" size="small" required margin="normal" fullWidth error={!!errors.statusId} helperText={errors.statusId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-6">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Controller name="followUpDate" control={control} rules={{ required: "Next follow-up date is required" }}
                                    render={({ field, fieldState }) => (
                                        <FormControl fullWidth margin="normal" error={!!fieldState.error}>
                                            <DatePicker
                                                label="Next Follow-up Date"
                                                value={field.value}
                                                onChange={field.onChange}
                                                format="YYYY-MMM-DD"
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        fullWidth: true,
                                                        error: !!fieldState.error,
                                                        helperText: fieldState.error?.message,
                                                        onKeyDown: (e) => e.preventDefault(),
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="col-md-12">
                            <FormControl fullWidth margin="normal" error={!!errors.comments}>
                                <TextField label="Comments" multiline rows={3} size="small"
                                    {...register("comments", OBJECT_DESCRIPTION_RULE)} error={!!errors.comments} helperText={errors.comments?.message} autoComplete="off" />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                        </div>
                        <div className="col-md-6">
                            <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                                Save
                            </Button>
                            <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseStatusUpdate}>
                                Close
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default StatusUpdateComponent;